import React from 'react';
import { Typography } from 'antd';
const { Link } = Typography;

export const About = () => {
    return (
        <React.Fragment>
            <h1>About Bridger</h1>
            <p>
                Scientific silos can hinder innovation. These information "filter bubbles" and the
                growing challenge of information overload limit awareness across the literature,
                making it difficult to keep track of even narrow areas of interest, let alone
                discover new ones. Bridger is a project focused on facilitating discovery of
                scholars and their work, by locating commonalities and contrasts between scientists.
                This work was published in the CHI 2022 conference. If you would like more
                information, please check out{' '}
                <Link href="https://dl.acm.org/doi/10.1145/3491102.3501905" target="_blank">
                    The paper and video presentation
                </Link>
                .
            </p>
            <p>
                This application allows you to search for an author and get Bridger-powered recommendations
                for other authors who work on similar tasks, but use less similar methods, or
                vice-versa.
            </p>
            <p>
                Created by{' '}
                <Link href="https://www.jasport.org" target="_blank" rel="noopener noreferrer">
                    Jason Portenoy
                </Link>{' '}
                and{' '}
                <Link
                    href="https://tomhoper.github.io"
                    target="_blank"
                    rel="noopener noreferrer">
                    Tom Hope
                </Link>
                .
            </p>
        </React.Fragment>
    );
};
